import { toast } from 'sonner';

import { ApiError } from '@/lib/api-client';

/**
 * Shared `onError` handler for the publish mutations (listings + screenshots).
 * A 503 means the store credentials are not configured yet — the expected state
 * until they are set — so it surfaces as a reassuring warning rather than a
 * scary error. Everything else is a real failure.
 */
export function notifyPublishError(err: unknown): void {
  if (err instanceof ApiError && err.status === 503) {
    toast.warning('Store credentials aren’t configured yet — nothing was published.');
  } else {
    toast.error(err instanceof ApiError ? err.message : 'Publish failed.');
  }
}
